module.exports = __webpack_public_path__ + "img/sheets.3bf0d5bc.svg";